import { SignIn, SignUp } from "@clerk/react";
import { Seo } from "@/components/site/Seo";
import { Logo } from "@/components/site/Header";

export default function SignInPage({ signUp = false }) {
  return (
    <div className="min-h-screen bg-stone-100 flex flex-col" data-testid="sign-in-page">
      <Seo title="Admin sign in" noindex />
      <header className="px-6 md:px-12 py-6"><Logo /></header>
      <main className="flex-1 flex items-center justify-center px-4 pb-16">
        {signUp
          ? <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" fallbackRedirectUrl="/admin" />
          : <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp fallbackRedirectUrl="/admin" />}
      </main>
    </div>
  );
}
